import { createApp, defineAsyncComponent } from 'vue';
import store from 'shared/store';
import { createEventBus } from 'shared/tools/eventBus';
import {
	initFormKitSchema,
	formKitSchemaOptions,
} from 'shared/utils/initFormKitSchema';
import { dropdown } from '@formkit/pro';

async function mountAddToBasket() {
	const addToBasketMount = document.getElementById('add-to-basket');
	const eventBus = createEventBus();

	if (!addToBasketMount) {
		console.warn('[AddToBasket] Container not found');
		return;
	}

	const options = await formKitSchemaOptions({ proPlugins: false });
	const app = createApp({
		name: 'AddToBasketApp',
	});
	app.config.globalProperties.$eventBus = eventBus;
	app.component(
		'variant-selector',
		defineAsyncComponent(
			() =>
				import(
					/* webpackChunkName: "variant-selector" */ 'shared/components/product/variantSelector.vue'
				),
		),
	);
	app.component(
		'sample-consent-modal',
		defineAsyncComponent(
			() =>
				import(
					/* webpackChunkName: "sample-consent-modal" */ 'shared/components/product/sampleConsentModal.vue'
				),
		),
	);
	app.component(
		'variant-add-to-basket',
		defineAsyncComponent(
			() =>
				import(
					/* webpackChunkName: "variant-add-to-basket" */ 'shared/components/product/variantAddToBasket.vue'
				),
		),
	);
	app.component(
		'variant-datasheet',
		defineAsyncComponent(
			() =>
				import(
					/* webpackChunkName: "variant-datasheet" */ 'shared/components/product/variantDatasheet.vue'
				),
		),
	);
	app.component(
		'variant-hcp-datasheet',
		defineAsyncComponent(
			() =>
				import(
					/* webpackChunkName: "variant-hcp/datasheet" */ 'shared/components/product/hcpProduct/variantHcpDatasheet.vue'
				),
		),
	);
	app.component(
		'read-only-description',
		defineAsyncComponent(
			() =>
				import(
					/* webpackChunkName: "variant-datasheet" */ 'shared/components/product/detailViewComponents/readOnlyDescription.vue'
				),
		),
	);
	app.component(
		'add-sample-to-basket',
		defineAsyncComponent(
			() =>
				import(
					/* webpackChunkName: "add-sample-to-basket" */ 'shared/components/product/addSampleToBasket.vue'
				),
		),
	);
	app.component(
		'hcp-popup',
		defineAsyncComponent(
			() =>
				import(
					/* webpackChunkName: "hcp-popup" */ 'shared/components/product/hcpPopup.vue'
				),
		),
	);
	app.component(
		'add-to-basket-legacy',
		defineAsyncComponent(
			() =>
				import(
					/* webpackChunkName: "add-to-basket-legacy" */ 'shared/components/product/addToBasket.vue'
				),
		),
	);
	app.component(
		'checkout-modal-login',
		defineAsyncComponent(
			() =>
				import(
					/* webpackChunkName: "checkout-modal-login" */ 'multisite/components/checkout/checkoutModalLogin.vue'
				),
		),
	);
	await initFormKitSchema(app, {
		...options,
		proPlugins: { dropdown },
	});
	app.use(store);
	app.mount(addToBasketMount);
}

mountAddToBasket().catch((error) => {
	console.error('Error mounting AddToBasket:', error);
});

